import log from "src/helpers/log";
import getImageSize from "./helpers/getImageSize";
import { FetchImageUri } from "./types";

const fetchImageUri: FetchImageUri = async (url) => {
	const res = await fetch(url);
	if (!res.ok) {
		log.error(
			{ status: res.status, url, statusText: res.statusText },
			"Failed to fetch image buffer from src",
		);
		return null;
	}
	const reader = new FileReader();
	reader.readAsDataURL(await res.blob());
	const base64DataWithoutPrefix = await new Promise<string>((resolve, reject) => {
		reader.onloadend = async () => {
			try {
				const base64data = reader.result;
				if (typeof base64data === "string") {
					const base64DataWithoutPrefix = base64data.split(",")[1];
					if (base64DataWithoutPrefix != null) {
						resolve(base64DataWithoutPrefix);
					}
				}
			} catch (err) {
				reject(err);
			}
			reject(new Error("Invalid base64 data"));
		};
	});
	const contentType = res.headers.get("content-type") ?? "image/jpeg";
	const uri = `data:${contentType};base64,${base64DataWithoutPrefix}`;
	const { width, height } = await getImageSize(uri);
	return { uri, width, height, base64Data: base64DataWithoutPrefix };
};
export default fetchImageUri;
